import { APPARENCES, LIBELLES_APPARENCE, type Apparence } from '@rh/shared';

/** Soleil : style clair. */
export function IconeJour() {
  return (
    <svg className="icone-apparence" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path
        d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Croissant de lune : style sombre. */
export function IconeNuit() {
  return (
    <svg className="icone-apparence" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconeApparence({ apparence }: { apparence: Apparence }) {
  return apparence === 'sombre' ? <IconeNuit /> : <IconeJour />;
}

/** Choix clair ou sombre, l'icône jour ou nuit devant chaque libellé. */
export function ChoixApparence({
  nom,
  valeur,
  onChange,
  desactive = false,
}: {
  nom: string;
  valeur: Apparence;
  onChange: (apparence: Apparence) => void;
  desactive?: boolean;
}) {
  return (
    <fieldset className="choix-apparence">
      <legend>Style d’affichage</legend>
      {APPARENCES.map((apparence) => (
        <label key={apparence} className={valeur === apparence ? 'actif' : undefined}>
          <input
            type="radio"
            name={nom}
            value={apparence}
            checked={valeur === apparence}
            disabled={desactive}
            onChange={() => onChange(apparence)}
          />
          <IconeApparence apparence={apparence} />
          <span>{LIBELLES_APPARENCE[apparence]}</span>
        </label>
      ))}
    </fieldset>
  );
}
